<template>
  <div class="position-relative" style="min-height: 150px">
    <div v-if="loading" class="table-overlay">
      <div class="table-spinner" />
    </div>
    <table class="table table-striped table-sm mb-0">
      <thead class="thead-dark text-uppercase">
        <tr>
          <th>Date</th>
          <th>Draft</th>
          <th class="d-none d-lg-table-cell">Zone</th>
          <th class="d-none d-lg-table-cell">Event</th>
          <th v-for="entity in entities" :key="entity.field" class="d-none d-lg-table-cell">{{ entity.label }}</th>
          <th>Place</th>
          <th class="d-none d-lg-table-cell">Score</th>
          <th class="d-none d-lg-table-cell">Points</th>
          <th v-if="previewed" class="d-none d-lg-table-cell col-points-after">Points After</th>
        </tr>
      </thead>
      <tbody v-if="rows.length">
        <tr
          v-for="row in rows"
          :key="row.id"
          :class="{ 'table-warning': isAffected(row) }"
        >
          <td>{{ formatDate(row.draft.start_date, 'long') }}</td>
          <td>
            <a :href="draftLink(row)" target="_blank" rel="noreferrer">{{ row.draft.name }}</a>
            <div class="d-lg-none">
              <div>Zone:&nbsp;{{ row.zone.name }}</div>
              <div>Event:&nbsp;<a :href="eventLink(row)" target="_blank" rel="noreferrer">{{ row.event.name }}</a></div>
              <div v-for="entity in entities" :key="entity.field">
                {{ entity.label }}:&nbsp;<template v-if="row[entity.field]">{{ row[entity.field].name }}<small v-if="row[entity.field].deleted"> (deleted)</small></template>
              </div>
            </div>
          </td>
          <td class="d-none d-lg-table-cell">{{ row.zone.name }}</td>
          <td class="d-none d-lg-table-cell"><a :href="eventLink(row)" target="_blank" rel="noreferrer">{{ row.event.name }}</a></td>
          <td v-for="entity in entities" :key="entity.field" class="d-none d-lg-table-cell">
            <template v-if="row[entity.field]">{{ row[entity.field].name }}<small v-if="row[entity.field].deleted"> (deleted)</small></template>
          </td>
          <td>
            {{ row.place }}
            <div class="d-lg-none">
              <div>Score:&nbsp;{{ row.score }}</div>
              <div>Points:&nbsp;{{ row.points }}</div>
              <div v-if="previewed">
                Points After:&nbsp;{{ row.points_after }}
                <span v-if="isAffected(row)" class="draws-dashboard__warn-icon" title="Points changed" />
              </div>
            </div>
          </td>
          <td class="d-none d-lg-table-cell">{{ row.score }}</td>
          <td class="d-none d-lg-table-cell">{{ row.points }}</td>
          <td v-if="previewed" class="d-none d-lg-table-cell">
            {{ row.points_after }}
            <span v-if="isAffected(row)" class="draws-dashboard__warn-icon" title="Points changed" />
          </td>
        </tr>
      </tbody>
      <tbody v-else-if="!loading">
        <tr>
          <td :colspan="colspan">{{ emptyText }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { defineComponent, computed } from '@vue/composition-api'
import { formatDate } from '@/utils/date'

export default defineComponent({
  name: 'AffectedResultsTable',
  props: {
    rows: { type: Array, required: true },
    loading: { type: Boolean, default: false },
    previewed: { type: Boolean, default: false },
    mode: {
      type: String,
      default: 'single',
      validator: value => ['single', 'both'].includes(value)
    },
    entityLabel: { type: String, default: '' },
    entityField: { type: String, default: '' },
    emptyText: { type: String, default: 'No results found for this period.' }
  },
  setup(props) {
    const entities = computed(() => (props.mode === 'both'
      ? [{ label: 'Rider', field: 'rider' }, { label: 'Horse', field: 'horse' }]
      : [{ label: props.entityLabel, field: props.entityField }]))

    const colspan = computed(() => 7 + entities.value.length + (props.previewed ? 1 : 0))

    function isAffected(row) {
      return props.previewed && String(row.points) !== String(row.points_after)
    }

    function draftLink(row) {
      return `/drafts-list/${row.draft.id}/events-list`
    }

    function eventLink(row) {
      return `/drafts-list/${row.draft.id}/events-list/event-create/${row.event.id}`
    }

    return {
      entities, colspan, formatDate, isAffected, draftLink, eventLink
    }
  }
})
</script>

<style scoped>
.col-points-after {
  width: 140px;
  white-space: nowrap;
}

.draws-dashboard__warn-icon {
  display: inline-block;
  background-image: url('~@/assets/img/sprite.png');
  background-size: 99px 97px;
  background-position: -22px 0px;
  width: 21px;
  height: 18px;
  vertical-align: middle;
  margin-left: 0.4rem;
}
</style>



// WEBPACK FOOTER //
// src/components/BoyStatus/AffectedResultsTable.vue